export default "__VITE_ASSET__B3IkA$Ge__"